/* eslint-disable no-unused-vars */
import { axiosInstance } from "../servicesSetupMock";

export const postSignTerm = async _data => {
  await new Promise(resolve => setTimeout(resolve, 10000));
  const retornoSimulado = {
    type: "application/pdf",
    size: 102400,
    blob: new Blob(["%PDF-1.4\n... Conteúdo Binário Simulado ..."], {
      type: "application/pdf"
    })
  };
  return { data: retornoSimulado.data };
};

export const postEcLogin = async (_cpf, _email) => {
  await new Promise(resolve => setTimeout(resolve, 10000));
  const { authVistoriadorEc } = await axiosInstance();
  const parseLocal = localStorage.getItem("TOKEN_NOW");
  if (parseLocal) {
    return JSON.parse(parseLocal);
  }
  return authVistoriadorEc;
};

export const getOcorrenciaCRM = async _idUnidade => {
  await new Promise(resolve => setTimeout(resolve, 3000));
  const { ocorrencia } = await axiosInstance();
  return ocorrencia;
};

export const downloadDocumentNew = async _data => {
  await new Promise(resolve => setTimeout(resolve, 10000));
  const retornoSimulado = {
    type: "application/pdf",
    size: 102400,
    blob: new Blob(["%PDF-1.4\n... Conteúdo Binário Simulado ..."], {
      type: "application/pdf"
    })
  };
  return { data: retornoSimulado.data };
};
